/**
 * Recently Viewed Products Service
 * Tracks products that the user has viewed
 */

const STORAGE_KEY = 'shop_recently_viewed';
const MAX_ITEMS = 10;

const recentlyViewedService = {
  // Add product to recently viewed
  addProduct(product) {
    try {
      let viewed = this.getProducts();
      
      // Remove if already exists (to avoid duplicates)
      viewed = viewed.filter(p => p.id !== product.id);
      
      // Add to beginning
      viewed.unshift({
        id: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        category: product.category,
        viewedAt: new Date().toISOString()
      });
      
      // Keep only MAX_ITEMS
      viewed = viewed.slice(0, MAX_ITEMS);
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
    } catch (error) {
      console.error('Error adding to recently viewed:', error);
    }
  },

  // Get all recently viewed products
  getProducts() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('Error getting recently viewed:', error);
      return [];
    }
  },

  // Clear recently viewed
  clear() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing recently viewed:', error);
    }
  }
};

export default recentlyViewedService;

